import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "genericPadding" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_val_form = _resolveComponent("val-form")!
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "backbutton",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.back()))
    }, [
      _hoisted_2
    ]),
    _createVNode(_component_localized_text, {
      localizedKey: "app_completailprofilo",
      text: "Completa il profilo",
      class: "fs_28 spaceCadet d-block mt-2 mb-5"
    }),
    _createVNode(_component_val_form, {
      onNext: _ctx.completeProfile,
      class: "registerContainer"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          _withDirectives(_createVNode("input", {
            type: "text",
            class: "genericInput",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.user.name = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.user.name],
            [_directive_localizedPlaceholder, {key: 'app_nome', value: 'Nome', afterText : '*'}]
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _withDirectives(_createVNode("input", {
            type: "text",
            class: "genericInput",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.user.surname = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.user.surname],
            [_directive_localizedPlaceholder, {key: 'app_cognome', value: 'Cognome', afterText : '*'}]
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _withDirectives(_createVNode("input", {
            type: "date",
            class: ["genericInput d-block w-100", {no_value : !_ctx.user.birthDate}],
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeDate && _ctx.changeDate(...args))),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.user.birthDate = $event)),
            required: ""
          }, null, 2), [
            [_directive_localizedPlaceholder, {key: 'app_dataDiNascita', value: 'Data di nascita', afterText : '*'}],
            [_vModelText, _ctx.user.birthDate]
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_mini_spinner, {
              key: 0,
              cssClass: 'my-5'
            }))
          : (_openBlock(), _createBlock("button", {
              key: 1,
              type: "submit",
              class: "genericButton bgGradient w-100 mt-5",
              disabled: _ctx.isDisabled
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_completeProfilo",
                text: "Completa profilo",
                class: "fs_14 white"
              })
            ], 8, ["disabled"]))
      ]),
      _: 1
    }, 8, ["onNext"])
  ]))
}